module.exports = __webpack_public_path__ + "static/media/bottle-placeholder.40d67b91.png";